import { ReactElement } from "react";

import { ReactComponent as ENG } from "@src/modules/shared/components/LanguageDropdown/flags/GB.svg";
import { ReactComponent as PL } from "@src/modules/shared/components/LanguageDropdown/flags/PL.svg";
import { ReactComponent as ES } from "@src/modules/shared/components/LanguageDropdown/flags/ES.svg";
import { ReactComponent as FR } from "@src/modules/shared/components/LanguageDropdown/flags/FR.svg";
// import { ReactComponent as RU } from "@src/modules/shared/components/LanguageDropdown/flags/RU.svg";

export interface Language {
  code: string;
  name: string;
  flag: ReactElement;
  isDisabled: boolean;
}

export const LANGUAGES: Language[] = [
  { code: "en", name: "ENG", flag: <ENG />, isDisabled: false },
  { code: "pl", name: "PL", flag: <PL />, isDisabled: false },
  { code: "es", name: "ES", flag: <ES />, isDisabled: false },
  // { code: "ru", name: "RU", flag: <RU />, isDisabled: true },
  { code: "fr", name: "FR", flag: <FR />, isDisabled: false },
];

export const SUPPORTED_LANGUAGE_CODES = LANGUAGES.filter(
  (lang) => !lang.isDisabled,
).map((lang) => lang.code);

export const DEFAULT_LANGUAGE = LANGUAGES[0];
